export interface ISubscription {
  id: string;
  name: string;
  durationType: SubscriptionDurationTypesEnum;
  duration: number;
  isVisible: boolean;
  credits: number;
  creditsRolloverAmount: number;
  price: number;
  description: string;
}

export type ISubscriptionUpdateModel = Omit<
  ISubscription,
  "id" | "durationType" | "duration" | "price"
>;

export enum UserSubscriptionStatusEnum {
  incomplete = "incomplete",
  incomplete_expired = "incomplete_expired",
  trialing = "trialing",
  active = "active",
  past_due = "past_due",
  canceled = "canceled",
  unpaid = "unpaid",
  paused = "paused",
}

export enum SubscriptionDurationTypesEnum {
  day = "day",
  week = "week",
  month = "month",
  year = "year",
}
